var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card", on: { click: _vm.goCarteira } }, [
    _c("div", { staticClass: "carteira" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Carteira")]),
      _c("span", { staticClass: "descricao" }, [_vm._v(_vm._s(_vm.data.title))])
    ]),
    _c("div", { staticClass: "emissor" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Emissor/Gestor")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.data.emissor))
      ])
    ]),
    _c("div", { staticClass: "saldo", attrs: { title: _vm.data.value } }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Saldo Bruto")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.currencyHelper.formatValue(_vm.data.value)))
      ])
    ]),
    _c(
      "div",
      { staticClass: "mesAtual", attrs: { title: _vm.data.mesAtual * 100 } },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v(_vm._s(_vm.monthLabel))]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.bound
                ? "---"
                : _vm.percentageHelper.formatPercentage(_vm.data.mesAtual)
            )
          )
        ])
      ]
    ),
    _c(
      "div",
      { staticClass: "percent-1", attrs: { title: _vm.data.percent1 * 100 } },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v("%")]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.bound
                ? "---"
                : _vm.percentageHelper.formatPercentagePoints(_vm.data.percent1)
            )
          )
        ])
      ]
    ),
    _c("div", { staticClass: "valor-1", attrs: { title: _vm.data.valor1 } }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("R$")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.currencyHelper.formatValue(_vm.data.valor1)))
      ])
    ]),
    _c(
      "div",
      { staticClass: "doze-meses", attrs: { title: _vm.data.dozeMeses * 100 } },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v("12 meses")]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.bound
                ? "---"
                : _vm.percentageHelper.formatPercentage(_vm.data.dozeMeses)
            )
          )
        ])
      ]
    ),
    _c(
      "div",
      { staticClass: "percent-2", attrs: { title: _vm.data.percent2 * 100 } },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v("%")]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.bound
                ? "---"
                : _vm.percentageHelper.formatPercentagePoints(_vm.data.percent2)
            )
          )
        ])
      ]
    ),
    _c("div", { staticClass: "valor-2", attrs: { title: _vm.data.valor2 } }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("R$")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(
          _vm._s(
            _vm.bound ? "---" : _vm.currencyHelper.formatValue(_vm.data.valor2)
          )
        )
      ])
    ]),
    _c(
      "div",
      {
        staticClass: "desde-inicio",
        attrs: { title: _vm.data.desdeInicio * 100 }
      },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v("Desde o início")]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(_vm.percentageHelper.formatPercentage(_vm.data.desdeInicio))
          )
        ])
      ]
    ),
    _c(
      "div",
      { staticClass: "percent-3", attrs: { title: _vm.data.percent3 * 100 } },
      [
        _c("span", { staticClass: "titulo" }, [_vm._v("%")]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.percentageHelper.formatPercentagePoints(_vm.data.percent3)
            )
          )
        ])
      ]
    ),
    _c("div", { staticClass: "valor-3", attrs: { title: _vm.data.valor3 } }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("R$")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.currencyHelper.formatValue(_vm.data.valor3)))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }